import { Router } from '@angular/router';

/**
 * Returns the router segments for the task detail (split-view) route.
 * Works for both space-root and folder-nested tables.
 */
export function taskDetailSegments(
  spaceId: number,
  folderId: number | null | undefined,
  tableId: number,
  rowNum: number
): (string | number)[] {
  return folderId
    ? [
        '/home/spaces',
        spaceId,
        'folders',
        folderId,
        'tables',
        tableId,
        'rows',
        rowNum,
      ]
    : ['/home/spaces', spaceId, 'tables', tableId, 'rows', rowNum];
}

/**
 * Navigates to the task detail (split-view) route.
 */
export function navigateToTaskDetail(
  router: Router,
  spaceId: number,
  folderId: number | null | undefined,
  tableId: number,
  rowNum: number
): void {
  router.navigate(taskDetailSegments(spaceId, folderId, tableId, rowNum));
}
